// Lightweight password strength heuristic used across registration + password-reset pages.
// Returns one of: "Weak" | "Fair" | "Strong" | "Very Strong" with a 0-100 score for the bar.
export function evaluatePasswordStrength(pw) {
  const value = pw || "";
  if (!value) return { label: "", score: 0, color: "bg-sage-light" };
  let score = 0;
  if (value.length >= 6) score += 1;
  if (value.length >= 8) score += 1;
  if (value.length >= 12) score += 1;
  if (/[a-z]/.test(value) && /[A-Z]/.test(value)) score += 1;
  if (/\d/.test(value)) score += 1;
  if (/[^A-Za-z0-9]/.test(value)) score += 1;
  const idx = Math.min(3, Math.max(0, score - 1));
  const steps = [
    { label: "Weak", pct: 25, color: "bg-terracotta" },
    { label: "Fair", pct: 50, color: "bg-amber-400" },
    { label: "Strong", pct: 75, color: "bg-sage" },
    { label: "Very Strong", pct: 100, color: "bg-sage-dark" },
  ];
  return { label: steps[idx].label, score: steps[idx].pct, color: steps[idx].color };
}
